import React from 'react'

interface SectionsProps {
  website?: any
  showSectionName?: boolean
}

export const Sections: React.FC<SectionsProps> = ({
  website,
  showSectionName,
}) => {
  let sections: string[] = []
  if (website?._id) {
    sections = website?._id?.split('/')
    sections.shift()
  }

  return (
    <>
      {sections?.map((section, index) => {
        if (index < sections.length - 1) {
          return (
            <span key={index}>
              {section}
              <i className="fa fa-chevron-right mx-2" />
            </span>
          )
        }
        return (
          <>
            <span key={index}>{section}</span>
            {showSectionName && <span className="ml-2">({website.name})</span>}
          </>
        )
      })}
    </>
  )
}
